import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";
import axios from "axios";
import { useDispatch } from "react-redux";
import Select from "react-select";
import { uploadImagecertifates } from "../../Redux/Actions/Action";
import { validateFile } from "../../utils/comman-function";

let searchTimeout = null;

function AddOfferPopup() {
  const [searchParams] = useSearchParams();
  const id = searchParams.get("id");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const token = localStorage.getItem("astroVani-admin-token");

  const {
    register,
    control,
    handleSubmit,
    setValue,
    watch,
    reset,
    formState: { errors, isSubmitted },
  } = useForm();

  const imageFor = watch("imageFor");
  const astrologerId = watch("astrologerId");
  const expertiseType = watch("expertiseType");
  const poojaId = watch("poojaId");

  const [isLoading, setIsLoading] = useState(false);
  const [uploadedImageUrl, setUploadedImageUrl] = useState("");

  const [astrologerOptions, setAstrologerOptions] = useState([]);
  const [expertiseOptions, setExpertiseOptions] = useState([]);
  const [couponOptions, setCouponOptions] = useState([]);

  const [isAstrologerLoading, setIsAstrologerLoading] = useState(false);
  const [isExpertiseLoading, setIsExpertiseLoading] = useState(false);
  const [isCouponLoading, setIsCouponLoading] = useState(false);
  const [poojaOptions, setPoojaOptions] = useState([]);
  const [isPoojaLoading, setIsPoojaLoading] = useState(false);

  /* ================= OPTIONS ================= */

  const IMAGE_FOR_OPTIONS = [
    { label: "Home", value: "home" },
    { label: "Wallet", value: "wallet" },
    { label: "Astrologer Profile", value: "astrologer_profile" },
    { label: "Astrologers List", value: "astrologers" },
    { label: "Astrologers Category", value: "astrologers_category" },
    { label: "Free Chat", value: "free_ai_chat" },
    { label: "Pooja Listing", value: "pooja_listing" },
    { label: "Pooja Details", value: "pooja_details" },
    { label: "Services", value: "services" },
    // { label: "Custom", value: "custom" },
  ];

  const DEFAULT_POPUP_OPTIONS = [
    { label: "Global", value: "global" },
    { label: "Recharge Count Zero", value: "rechargeCountZero" },
    { label: "Free Chat Not Availed", value: "aifreeChat" },
    { label: "Recharge Count More Than Or Equal To One", value: "rechargeCountMoreThanOne" },
  ];

  const [popupTypeOptions, setPopupTypeOptions] = useState(DEFAULT_POPUP_OPTIONS);

  const DISPLAY_SCREENS_OPTIONS = IMAGE_FOR_OPTIONS.filter((o) => o.value !== "free_ai_chat" && o.value !== "astrologers_category" && o.value !== "pooja_details" && o.value !== "astrologer_profile");

  /* ================= FETCH POPUP (EDIT) ================= */

  useEffect(() => {
    if (!id) return;

    const fetchPopupDetails = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASEURL}/admin/offerPopup/${id}`,
          { headers: { Authorization: token } }
        );

        const data = res.data.data;

        const formatDateTimeLocal = (d, t) => {
          if (!d) return "";
          // Make sure date is YYYY-MM-DD
          const dPart = d.includes("T") ? d.split("T")[0] : d.substring(0, 10);
          const tPart = t || "00:00";
          return `${dPart}T${tPart}`;
        };

        reset({
          popupTitle: data.popupTitle || "",
          popupType: data.popupType || "",
          imageFor: data.imageFor || "",
          astrologerId: data.astrologerId || "",
          expertiseType: data.expertiseType || "",
          couponId: data.couponId || "",
          poojaId: data.poojaId || "",
          displayScreens: data.displayScreens || "",
          startDate: formatDateTimeLocal(data.startDate, data.startTime),
          endDate: formatDateTimeLocal(data.endDate, data.endTime),
        });

        setUploadedImageUrl(data.imageUrl || "");

        if (data.imageFor === "astrologer_profile") fetchAstrologers();
        if (data.imageFor === "astrologers_category") fetchExpertise();
        if (data.imageFor === "pooja_details") fetchPoojas();
      } catch {
        toast.error("Failed to fetch popup details");
      }
    };

    fetchPopupDetails();
  }, [id]);

  /* ================= ASTROLOGER SEARCH ================= */

  const fetchAstrologers = async (search = "") => {
    try {
      setIsAstrologerLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/getVerifiedAstrologersList`,
        {
          headers: { Authorization: token },
          params: search ? { fullName: search } : {},
        }
      );

      const options = (res.data?.data || []).map((a) => ({
        value: a._id,
        label: `${a.astrologerName} `,
      }));

      setAstrologerOptions(options);
    } catch {
      toast.error("Failed to load astrologers");
    } finally {
      setIsAstrologerLoading(false);
    }
  };

  const handleAstrologerSearch = (value) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => fetchAstrologers(value), 400);
  };

  /* ================= EXPERTISE LIST ================= */

  const fetchExpertise = async () => {
    try {
      setIsExpertiseLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/expertise`,
        { headers: { Authorization: token } }
      );

      const options = (res.data?.data || []).map((e) => ({
        value: e._id,
        label: e.expertiseName,
      }));

      setExpertiseOptions(options);
    } catch {
      toast.error("Failed to load expertise");
    } finally {
      setIsExpertiseLoading(false);
    }
  };

  const fetchCoupons = async (search = "") => {
    try {
      setIsCouponLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/coupon`,
        {
          headers: { Authorization: token },
          params: search ? { couponName: search } : {},
        }
      );

      const options = (res.data?.data || []).map((c) => ({
        value: c._id,
        label: `${c.couponName} (${c.couponCode}) : ${c.category === "flat_extra_percentage" ? `${c.discountValue}% off` : `₹${c.discountValue} off`}`,
      }));

      setCouponOptions(options);
    } catch {
      toast.error("Failed to load coupons");
    } finally {
      setIsCouponLoading(false);
    }
  };

  const handleCouponSearch = (value) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => fetchCoupons(value), 400);
  };

  /* ================= POOJA LIST ================= */

  const fetchPoojas = async (search = "") => {
    try {
      setIsPoojaLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/pooja`,
        {
          headers: { Authorization: token },
          params: { page: 1, limit: 500, ...(search ? { search } : {}) },
        }
      );

      const data = res.data;
      const list = Array.isArray(data?.data?.data)
          ? data.data.data
          : Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];

      const options = list.map((p) => ({
        value: p._id,
        label: p.name,
      }));

      setPoojaOptions(options);
    } catch {
      toast.error("Failed to load poojas");
    } finally {
      setIsPoojaLoading(false);
    }
  };

  const handlePoojaSearch = (value) => {
    clearTimeout(searchTimeout);
    searchTimeout = setTimeout(() => fetchPoojas(value), 400);
  };

  useEffect(() => {
    if (imageFor === "astrologer_profile") fetchAstrologers();
    if (imageFor === "astrologers_category") fetchExpertise();
    if (imageFor === "pooja_details") fetchPoojas();
  }, [imageFor]);

  const fetchBuckets = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BASEURL}/admin/loyaltyOffer?isActive=true`,
        {
          headers: { Authorization: token },
          params: { limit: 1000 },
        }
      );

      const data = res.data;
      const list = Array.isArray(data?.data?.data)
          ? data.data.data
          : Array.isArray(data?.data)
          ? data.data
          : Array.isArray(data)
          ? data
          : [];

      const bucketOptions = list.map((b) => ({
        value: b.title,
        label: b.title,
      }));

      setPopupTypeOptions([...DEFAULT_POPUP_OPTIONS, ...bucketOptions]);
    } catch {
      console.error("Failed to load buckets");
    }
  };

  useEffect(() => {
    fetchCoupons();
    fetchBuckets();
  }, []);

  /* ================= IMAGE UPLOAD ================= */

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    if (!validateFile(file, "image")) {
      return;
    }

    try {
      const imgUrl = await dispatch(uploadImagecertifates(file));
      setUploadedImageUrl(imgUrl[0]);
      toast.success("Image uploaded successfully!");
    } catch {
      toast.error("Image upload failed");
    }
  };

  /* ================= SUBMIT ================= */

  const onSubmit = async (data) => {
    if (!uploadedImageUrl) {
      toast.error("Please upload image");
      return;
    }

    const currentDateTime = new Date();
    const startDateTime = new Date(data.startDate);
    const endDateTime = new Date(data.endDate);

    // Subtract 5 minutes grace period for current time to avoid false positives
    const nowGrace = new Date(currentDateTime.getTime() - 5 * 60000);

    if (!id && startDateTime < nowGrace) {
      toast.error("Start date and time cannot be in the past");
      return;
    }

    if (startDateTime >= endDateTime) {
      toast.error("End date and time must be after start date and time");
      return;
    }

    setIsLoading(true);

    const startDatePart = data.startDate.split("T")[0];
    const startTimePart = data.startDate.split("T")[1] || "00:00";
    const endDatePart = data.endDate.split("T")[0];
    const endTimePart = data.endDate.split("T")[1] || "00:00";

    const payload = {
      popupTitle: data.popupTitle,
      imageFor: data.imageFor,
      imageUrl: uploadedImageUrl,
      popupType: data.popupType || "global",
      displayScreens: data.displayScreens || "",
      isActive: true,
      startDate: startDatePart,
      startTime: startTimePart,
      endDate: endDatePart,
      endTime: endTimePart,

      ...(data.imageFor === "astrologer_profile" && data.astrologerId
        ? { astrologerId: data.astrologerId }
        : {}),

      ...(data.imageFor === "astrologers_category" && data.expertiseType
        ? { expertiseType: data.expertiseType }
        : {}),

      ...(data.imageFor === "pooja_details" && data.poojaId
        ? { poojaId: data.poojaId }
        : {}),

      ...(data.couponId ? { couponId: data.couponId } : {}),
    };

    try {
      if (id) {
        await axios.patch(
          `${process.env.REACT_APP_BASEURL}/admin/offerPopup/${id}`,
          payload,
          { headers: { Authorization: token } }
        );
        toast.success("Popup updated successfully!");
      } else {
        await axios.post(
          `${process.env.REACT_APP_BASEURL}/admin/offerPopup`,
          payload,
          { headers: { Authorization: token } }
        );
        toast.success("Popup added successfully!");
      }

      navigate("/offer-list");
    } catch (error) {
      console.error("Error while adding/updating offer popup:", error);
      toast.error(id ? error?.response?.data?.message || "Failed to update popup" : error?.response?.data?.message || "Failed to add popup");
    } finally {
      setIsLoading(false);
    }
  };

  /* ================= REGISTER DYNAMIC ================= */

  useEffect(() => {
    register("astrologerId", { required: imageFor === "astrologer_profile" });
    register("expertiseType", { required: imageFor === "astrologers_category" });
    register("poojaId", { required: imageFor === "pooja_details" });
  }, [imageFor]);

  /* ================= UI ================= */

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h4 className="fw-bold mb-0">{id ? "Edit" : "Add"} Offer Popup</h4>
        <button
          type="button"
          className="btn btn-primary"
          style={{ position: "relative", zIndex: 10 }}
          onClick={() => navigate("/offer-list")}
        >
          Back
        </button>
      </div>
      <div className="card-body">
        <form className="row g-4" onSubmit={handleSubmit(onSubmit)}>
          {/* Popup Title */}
          <div className="col-sm-6">
            <label className="form-label">Popup Title</label>
            <input
              className={`form-control ${errors.popupTitle ? "is-invalid" : ""}`}
              {...register("popupTitle", { required: "Popup title is required" })}
            />
            {errors.popupTitle && (
              <small className="text-danger">{errors.popupTitle.message}</small>
            )}
          </div>

          {/* Start Date & Time */}
          <div className="col-sm-6">
            <label className="form-label">Start Date & Time</label>
            <input
              type="datetime-local"
              className={`form-control ${errors.startDate ? "is-invalid" : ""}`}
              {...register("startDate", { required: "Start date and time is required" })}
            />
            {errors.startDate && <small className="text-danger">{errors.startDate.message}</small>}
          </div>

          {/* End Date & Time */}
          <div className="col-sm-6">
            <label className="form-label">End Date & Time</label>
            <input
              type="datetime-local"
              className={`form-control ${errors.endDate ? "is-invalid" : ""}`}
              {...register("endDate", { required: "End date and time is required" })}
            />
            {errors.endDate && <small className="text-danger">{errors.endDate.message}</small>}
          </div>

          {/* Redirect To */}
          {/* <div className="col-sm-6">
            <label className="form-label">Redirect To</label>
            <select className={`form-control ${errors.imageFor ? "is-invalid" : ""}`} {...register("imageFor", { required: "Please select redirect option" })}>
              <option value="">Select</option>
              {IMAGE_FOR_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
            {errors.imageFor && (
              <small className="text-danger">{errors.imageFor.message}</small>
            )}
          </div> */}
          <div className="col-sm-6">
            <label className="form-label">Redirect To</label>

            <Controller
              name="imageFor"
              control={control}
              rules={{ required: "Please select redirect option" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={IMAGE_FOR_OPTIONS}
                  placeholder="Select"
                  value={IMAGE_FOR_OPTIONS.find(
                    (option) => option.value === field.value
                  )}
                  onChange={(option) => field.onChange(option?.value)}
                />
              )}
            />

            {errors.imageFor && (
              <small className="text-danger">
                {errors.imageFor.message}
              </small>
            )}
          </div>

          {/* Display Screens */}
          <div className="col-sm-6">
            <label className="form-label">Display Screens</label>
            <Controller
              name="displayScreens"
              control={control}
              rules={{ required: "Please select display screens" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={DISPLAY_SCREENS_OPTIONS}
                  placeholder="Select"
                  value={DISPLAY_SCREENS_OPTIONS.find(
                    (option) => option.value === field.value
                  ) || null}
                  onChange={(option) => field.onChange(option?.value)}
                />
              )}
            />
            {errors.displayScreens && (
              <small className="text-danger">
                {errors.displayScreens.message}
              </small>
            )}
          </div>

          {/* Astrologer Select */}
          {imageFor === "astrologer_profile" && (
            <div className="col-sm-6">
              <label className="form-label">Astrologer</label>
              <Select
                options={astrologerOptions}
                isLoading={isAstrologerLoading}
                onInputChange={handleAstrologerSearch}
                onChange={(o) => setValue("astrologerId", o?.value || "")}
                value={astrologerOptions.find((o) => o.value === astrologerId) || null}
                isClearable
                placeholder="Search astrologer"
              />
              {errors.astrologerId && (
                <small className="text-danger">Please select an astrologer</small>
              )}
            </div>
          )}

          {/* Expertise Select */}
          {imageFor === "astrologers_category" && (
            <div className="col-sm-6">
              <label className="form-label">Expertise Type</label>
              <Select
                options={expertiseOptions}
                isLoading={isExpertiseLoading}
                onChange={(o) => setValue("expertiseType", o?.value || "")}
                value={expertiseOptions.find((o) => o.value === expertiseType) || null}
                isClearable
                placeholder="Select expertise"
              />
              {errors.expertiseType && (
                <small className="text-danger">Please select expertise type</small>
              )}
            </div>
          )}

          {/* Pooja Select */}
          {imageFor === "pooja_details" && (
            <div className="col-sm-6">
              <label className="form-label">Pooja</label>
              <Select
                options={poojaOptions}
                isLoading={isPoojaLoading}
                onInputChange={handlePoojaSearch}
                onChange={(o) => setValue("poojaId", o?.value || "")}
                value={poojaOptions.find((o) => o.value === poojaId) || null}
                isClearable
                placeholder="Search pooja"
              />
              {errors.poojaId && (
                <small className="text-danger">Please select a pooja</small>
              )}
            </div>
          )}

          {/* Popup Type */}
          {/* <div className="col-sm-6">
            <label className="form-label">Popup Type</label>
            <select className={`form-control ${errors.popupType ? "is-invalid" : ""}`} {...register("popupType", { required: "Please select popup type" })}>
              <option value="">Select</option>
              {OFFER_POPUP_TYPE_OPTIONS.map((o) => (
                <option key={o.value} value={o.value}>
                  {o.label}
                </option>
              ))}
            </select>
            {errors.popupType && (
              <small className="text-danger">{errors.popupType.message}</small>
            )}
          </div> */}
          <div className="col-sm-6">
            <label className="form-label">Popup Type</label>

            <Controller
              name="popupType"
              control={control}
              rules={{ required: "Please select popup type" }}
              render={({ field }) => (
                <Select
                  {...field}
                  options={popupTypeOptions}
                  placeholder="Select"
                  value={popupTypeOptions.find(
                    (option) => option.value === field.value
                  ) || null}
                  onChange={(option) => field.onChange(option?.value)}
                />
              )}
            />

            {errors.popupType && (
              <small className="text-danger">
                {errors.popupType.message}
              </small>
            )}
          </div>


          {/* Coupon Select (Optional) */}
          {imageFor === "wallet" && <div className="col-sm-6">
            <label className="form-label">Link Coupon</label>
            <Select
              options={couponOptions}
              isLoading={isCouponLoading}
              onInputChange={handleCouponSearch}
              onChange={(o) => setValue("couponId", o?.value || "")}
              value={couponOptions.find((o) => o.value === watch("couponId")) || null}
              isClearable
              placeholder="Search coupon (Optional)"
              styles={{
                menuList: (base) => ({
                  ...base,
                  maxHeight: "300px",
                  overflowY: "auto",
                }),
              }}
            />
          </div>}

          {/* Image Upload */}
          <div className="col-sm-6">
            <label className="form-label">Upload Image</label>
            <input
              className="form-control"
              type="file"
              onChange={handleImageUpload}
            />

            {isSubmitted && !uploadedImageUrl && !id && (
              <small className="text-danger">Image is required</small>
            )}

            {uploadedImageUrl && (
              <img
                src={uploadedImageUrl}
                alt="popup"
                style={{ maxWidth: 150, maxHeight: 150, marginTop: 10 }}
              />
            )}
          </div>

          <div className="col-12">
            <button className="btn btn-primary" disabled={isLoading}>
              {id ? "Update Popup" : "Add Popup"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default AddOfferPopup;
